import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

export const login = data => {
    return api.post(
        `${baseApi}/auth/login`,
        {
            ...data
        },
        {
            headers: {
                isToken: true
            }
        }
    );
};

export const QueryCompanyCode = data => {
    return api.post(``, data);
};

export const QueryServeDate = () => {
    return api.get(`/system/getServerTime`);
};

export const weChatLogin = data => {
    return api.get(`${baseApi}/auth/loginWechat?code=${data.code}`, {
        headers: {
            isToken: true
        }
    });
};

export const getWeChatToken = () => {
    return api.post(`${baseApi}`, data);
};

export const bindWeChat = data => {
    return api.get(`${baseApi}/weChat/addWeChat?code=${data.code}`);
};

export const loginOut = () => {
    return api.get(`${baseApi}/auth/logout`);
};

export const doLogin = data => {
    return api.post(`${baseApi}/auth/doLogin`, {
        ...data
    });
};

export const QueryTanent = ({ tenantName }) => {
    return api.get(`/tenant/listByTenantName/${tenantName}`);
};

// ============

// 菜单管理列表
export const getMenuList = data => {
    return api.get(`${baseApi}/menu/getMenuList/${data.parentId}`);
};

// 菜单管理列表
export const saveMenu = data => {
    return api.post(`${baseApi}/menu/addMenu`, data);
};

// 菜单编辑
export const updateMenu = data => {
    return api.post(`${baseApi}/menu/updateMenu`, data);
};

// 菜单删除
export const deleteMenu = menuId => {
    return api.post(`${baseApi}/menu/removeMenu/${menuId}`);
};

// 菜单状态
export const changeMenuStatus = (menuId, status) => {
    return api.post(`${baseApi}/menu/updateStatus/${menuId}/${status}`);
};

// 菜单树形
export const getMenuTree = () => {
    return api.get(`${baseApi}/menu/getMenuTree`);
};

// 批量修改排序
export const updateMenuSort = data => {
    return api.post(`${baseApi}/menu/updateMenuBatch`, data);
};

// ===============

// 角色列表
export const getRoleList = data => {
    return api.post(`${baseApi}/role/getRoleList`, data);
};

// 新增角色
export const addRole = data => {
    return api.post(`${baseApi}/role/addRole`, data);
};

// 更新角色
export const updateRole = data => {
    return api.post(`${baseApi}/role/updateRole`, data);
};

// 删除角色
export const deleteRole = roleId => {
    return api.post(`${baseApi}/role/removeRole/${roleId}`);
};

// 修改角色状态
export const changeRoleStatus = (roleId, status) => {
    return api.post(`${baseApi}/role/updateStatus/${roleId}/${status}`);
};

// 角色添加菜单
export const saveRoleMenuAuth = data => {
    return api.post(`${baseApi}/role/saveRoleMenuRel`, data);
};

// 角色菜单
export const getRoleMenuAuth = roleId => {
    return api.post(`${baseApi}/role/getRoleButtonList/${roleId}`);
};

// 角色排序
export const sortRole = data => {
    return api.post(`/role/updateRoleSort`, data);
};

// 使用情况

export const QueryUsage = data => {
    return api.post(`${baseApi}/system/getSystemUsage`, data);
};

// 各人使用情况

export const QueryUserUsage = data => {
    return api.post(`${baseApi}/system/getSystemUsage4UserListPage`, data);
};

// 下属使用情况
export const QueryUserSub = data => {
    return api.post(`${baseApi}/system/getSystemUsage4SubordinatesPage`, data);
};

// 问题反馈
export const QueryFeedback = data => {
    return api.post(`/recordFeedback/getRecordFeedbackPage`, data);
};

export const AddFeedback = data => {
    return api.post(`/recordFeedback/addRecordFeedback`, data);
};

export const UpdateFeedback = data => {
    return api.post(`/recordFeedback/updateRecordFeedback`, data);
};

export const SolveFeedback = data => {
    return api.post(`/recordFeedback/updateRecordFeedback2Solve`, data);
};

export const QueryFeedbackInfo = ({ feedbackId }) => {
    return api.get(`/recordFeedback/getRecordFeedbackVoByFeedbackId/${feedbackId}`);
};

export const QueryUserFeedbackList = data => {
    return api.post(`/recordFeedback/getRecordFeedbackListByConditions`, data);
};

// 查询

export const QueryQuickMenu = ({ menuName }) => {
    return api.get(`/menu/getMenuListFast/${menuName}`);
};

export const QuerySettingData = data => {
    return api.post(`/fieldIntegrity/getFieldIntegrityPage`, data);
};

export const SaveSettingData = data => {
    return api.post(`/fieldIntegrity/add`, data);
};

export const DeleteSettingData = ({ integrityId }) => {
    return api.delete(`/fieldIntegrity/delete/${integrityId}`);
};

export const UpdateSettingData = data => {
    return api.post(`/fieldIntegrity/update`, data);
};

export const UpdateSettingDataAll = data => {
    return api.post(`/fieldIntegrity/updateAll`, data);
};

export const RefreshSettingData = ({ tableName }) => {
    return api.get(`/fieldIntegrity/refreshFieldIntegrityBySetting/${tableName}`);
};
